import React, { Component, Fragment } from 'react';
import { graphql, createRefetchContainer } from 'react-relay';

import PropTypes from 'prop-types';
import clsx from 'clsx';
import _ from 'lodash';

import { withStyles } from '@material-ui/styles';
import {
    Grid
} from '@material-ui/core';

import { Carousel } from 'react-responsive-carousel';
import useStyles from './styles.js';

class Icons extends Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            rec_per_page: 20,
            imageList: props.getPhotoLibrary && props.getPhotoLibrary.getPhotoLibrary ? props.getPhotoLibrary.getPhotoLibrary : [],
            selected_image : null
        }
        
    }

    componentDidMount() {
      
    }

    componentWillUnmount() {
     
    }

    updateWindowDimensions() {
        
    }

    componentWillReceiveProps(nextProps) {
       
       

    }

    _refetch = () => {
        // this.props.relay.refetch({ page: this.state.page, rec_per_page: this.state.rec_per_page, event_id: this.state.event_id },
        //     null,
        //     () => { console.log("refetch done"); },
        //     { force: true },
        // );
    }

    updateSelectedItem=(image, e)=>{
        this.setState({
            selected_image : image._id
        },()=>{
            this.props.onIconSelected(this.props.id,image._id, image.image)
        })
    }

    render() {
        const { classes } = this.props;
        return (
            <Grid
                container
                direction="row"
                justify="center"
                alignItems="center"
            >
               {
                    this.state.imageList && this.state.imageList.map((image) => {
                    return (<div
                            className={this.state.selected_image == image._id ? classes.selectedImage : classes.image}
                            onClick={(e)=>{this.updateSelectedItem(image,e)}}>
                                <img src={image.image} className={ this.state.selected_image == image._id ? classes.selectedIcon : classes.icon}/>
                                <span style={{textAlign: 'center'}}>{image.name}</span>
                            </div>)
                    })
                }
            </Grid>

        )
    }
}

Icons.propTypes = {
    className: PropTypes.string,
};

export default createRefetchContainer(
    withStyles(useStyles)(Icons),
    {
        getPhotoLibrary: graphql`
        fragment Icons_getPhotoLibrary on Query
        @argumentDefinitions(  
            page:{type:"Int"},
            rec_per_page:{type:"Int"},
            name:{type : "String"}, 
            file_type: {type : "String"}, 
            type: {type : "String"}
            
        ) {
            getPhotoLibrary(page: $page, rec_per_page: $rec_per_page, name:$name, file_type: $file_type, type: $type){
                _id
                name
                image

            }
      	}
    `
    },
    graphql`
    query IconsRefetchQuery($page: Int, $rec_per_page: Int, $name:String, $file_type: String, $type: String) {
      ...Icons_getPhotoLibrary @arguments(page: $page, rec_per_page: $rec_per_page, name:$name, file_type: $file_type, type: $type)      
    }
  `,
);